

























































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { AuthModule } from '@/store/Auth/AuthModule';
import BankingIntegrations from '@/models/Settings/Institutions/Integrations/BankingIntegrations';
import CardIntegrations from '@/models/Settings/Institutions/Integrations/CardIntegrations';
import TransactionMonitoringIntegrations from '@/models/Settings/Institutions/Integrations/TransactionMonitoringIntegrations';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'NewIntegration' })
export default class extends SaascadaVueDialog {

    dialog = false;
    selectedBankingIntegrations: BankingIntegrations[] = [];
    selectedCardIntegrations: CardIntegrations[] = [];
    selectedTransactionMonitoringIntegrations: TransactionMonitoringIntegrations[] = [];

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.selectedBankingIntegrations = AuthModule.me.institution.config.bankingIntegrations;
            this.selectedCardIntegrations = AuthModule.me.institution.config.cardIntegrations;
            this.selectedTransactionMonitoringIntegrations = AuthModule.me.institution.config.transactionMonitoringIntegrations;
        }
    }

    get allBankingIntegrations() {
        return ListUtils.bankingIntegrationsOptions();
    }

    get allCardIntegrations() {
        return ListUtils.cardIntegrationsOptions();
    }

    get allTransactionMonitoringIntegrations() {
        return ListUtils.transactionMonitoringIntegrationsOptions();
    }

    async cancel() {
        this.dialog = false;
    }

    async save() {
        this.dialog = false;
    }

}
